import React from 'react';

import InventoryCard from './InventoryCard';
import InventoryTable, { InventoryTableRow } from './InventoryTable';
import { PairedFlightRow } from './useCharterInventory';

type ReturningFlightsCardProps = {
  rows: Array<PairedFlightRow>;
  label: string;
};

export default function ReturningFlightsCard({ rows, label }: ReturningFlightsCardProps) {
  const tableRows = rows.flatMap<InventoryTableRow | null>((row) => {
    if (!row.returning) {
      // Render empty rows to match the number of departing flight fare inventories for alignment.
      return row.departing.fareInventory.map(() => null);
    }

    // Render return flight inventories. Visual alignment assumes fare inventory counts match between flights.
    return row.returning.fareInventory.map((fare) => ({
      stayDuration: row.stayDuration,
      flight: row.returning,
      fare,
      uniqueKey: `${row.id}-${fare.bookingClass}`,
    }));
  });

  return (
    <InventoryCard title="Returning flights" subheader={`${label} · paired by stay duration`}>
      <InventoryTable
        rows={tableRows}
        emptyMessage="No returning flights matched the selected stay durations."
        showStayDuration
      />
    </InventoryCard>
  );
}
